import Vue from 'vue'
import App from './App.vue'
import router from './router'
import qs from 'qs'
import {Button, Message, Upload } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store'
import { post, fetch, patch, put } from './utils/http'
let messageInstance = null;
const overrideMessage = (options) => {
  if(messageInstance) {
    messageInstance.close();
  }
  messageInstance = Message(options);
};
["error","success","info","warning"].forEach(type => {
  overrideMessage[type] = options => {
    if (typeof options === "string") {
      options = {
        message: options
      };
    }
    options.type = type;
    return overrideMessage(options);
  };
});
Vue.use(Upload)
Vue.use(Button)
Vue.prototype.$message = overrideMessage
Vue.prototype.$qs = qs
//定义全局变量
Vue.prototype.$post = post;
Vue.prototype.$fetch = fetch;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
